import { getMatchKickoffDate, isMatchStarted, matchHasKnownKickoffTime } from '@/stores/matchStore';
import type { Match } from '@/types';

function parseToYmd(dateStr: string | undefined): string | null {
  if (!dateStr?.trim()) return null;
  const s = dateStr.trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Message d’erreur si création d’observation interdite ; `null` si autorisée. */
export function getMatchObservationBlockMessage(match: Match, at: Date = new Date()): string | null {
  if (isMatchStarted(match, at)) return null;
  if (!parseToYmd(match.date)) {
    return 'Date du match inconnue — observation impossible pour le moment.';
  }
  if (!matchHasKnownKickoffTime(match)) {
    return 'Heure du match inconnue — observation impossible pour le moment.';
  }
  const kickoff = getMatchKickoffDate(match);
  if (!kickoff) {
    return 'Heure du match inconnue — observation impossible pour le moment.';
  }
  const when = kickoff.toLocaleString('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  return `Observation possible à partir du ${when}.`;
}
